<template>
    <card class="m-0 p-0">
        <form v-loading.lock="saving"
              :element-loading-text="$t('Saving...')">
            <div class="card-body row pt-0">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-6">
                            <label>{{$t('Password')}}</label>
                            <fg-input v-model="password"
                                      input-classes="input-with-right-icon"
                                      v-validate="validations.passwordOpt"
                                      :info="$t('note upper and lower case')"
                                      :error="errors.first('password')"
                                      name="password"
                                      autocomplete="off"
                                      :placeholder="$t('Password')"
                                      :type="isPasswordVisible ? 'text' : 'password'">
                                <template slot="addonRight">
                                    <button type="button" class="btn input-group-append btn-neutral btn-icon-right"
                                            @click="isPasswordVisible = !isPasswordVisible">
                                      <span class="input-group-text icon-right">
                                        <i v-if="isPasswordVisible" class="fa fa-eye fa-icon-width"/>
                                        <i v-else class="fa fa-eye-slash fa-icon-width"/>
                                      </span>
                                    </button>
                                </template>
                            </fg-input>
                        </div>
                        <div class="col-md-6">
                            <label>{{$t('New Password')}}</label>
                            <fg-input v-model="newPassword"
                                      input-classes="input-with-right-icon"
                                      v-validate="validations.passwordOpt"
                                      :info="$t('note upper and lower case')"
                                      :error="errors.first('newPassword')"
                                      name="newPassword"
                                      ref="newPassword"
                                      autocomplete="off"
                                      :placeholder="$t('New Password')"
                                      :type="isNewPasswordVisible ? 'text' : 'password'">
                                <template slot="addonRight">
                                    <button type="button" class="btn input-group-append btn-neutral btn-icon-right"
                                            @click="isNewPasswordVisible = !isNewPasswordVisible">
                                      <span class="input-group-text icon-right">
                                        <i v-if="isNewPasswordVisible" class="fa fa-eye fa-icon-width"/>
                                        <i v-else class="fa fa-eye-slash fa-icon-width"/>
                                      </span>
                                    </button>
                                </template>
                            </fg-input>
                            <label>{{$t('Repeat New Password')}}</label>
                            <fg-input v-model="repeatNewPassword"
                                      input-classes="input-with-right-icon"
                                      v-validate="'required|confirmed:newPassword'"
                                      :info="$t('note upper and lower case')"
                                      :error="errors.first('repeatNewPassword')"
                                      name="repeatNewPassword"
                                      autocomplete="off"
                                      :placeholder="$t('Repeat New Password')"
                                      :type="isRepeatNewPasswordVisible ? 'text' : 'password'">
                                <template slot="addonRight">
                                    <button type="button" class="btn input-group-append btn-neutral btn-icon-right"
                                            @click="isRepeatNewPasswordVisible = !isRepeatNewPasswordVisible">
                                      <span class="input-group-text icon-right">
                                        <i v-if="isRepeatNewPasswordVisible" class="fa fa-eye fa-icon-width"/>
                                        <i v-else class="fa fa-eye-slash fa-icon-width"/>
                                      </span>
                                    </button>
                                </template>
                            </fg-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer text-right">
                <p-button round native-type="submit" type="primary" class="btn btn-fill btn-wd" :disabled="saving"
                          @click.prevent="save">
                    {{ $t('Save') }}
                </p-button>
            </div>
            <div class="clearfix"></div>
        </form>
    </card>
</template>

<script>
  import get from 'lodash/get'

  export default {
    data () {
      return {
        password: null,
        isPasswordVisible: false,
        newPassword: null,
        isNewPasswordVisible: false,
        repeatNewPassword: null,
        isRepeatNewPasswordVisible: false,
        validations: {
          passwordOpt: {
            required: true,
            min: 5
          }
        },
      }
    },
    components: {},
    methods: {
      save: async function () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          return
        }

        try {
          const data = { password: this.password, newPassword: this.newPassword, email: this.$auth.user.email }
          await this.$auth.updateUser(data)
          this.password = null
          this.newPassword = null
          this.repeatNewPassword = null
          await this.$validator.reset()
          this.$notify({ type: 'success', message: 'Successfully saved' })
        } catch (e) {
          let message = e.message
          if (e.response) {
            message = get(JSON.parse(e.response.data.message), '[0].password', e.message)
          }
          this.$notify({ message, type: 'danger', title: 'Error' })
        }
      }
    },
    mounted() {
      this.$sidebar.showSidebar = false;
    },
    computed: {
      saving: function () {
        return this.$auth.updating
      }
    }
  }

</script>

<style lang="scss">
    .btn-icon-right {
        z-index: -1;
        padding: 0 !important;
    }
    .icon-right {
        z-index: 1;
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
    }
    .input-with-right-icon {
        border-right: 0 none !important;
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }
    .fa-icon-width {
        width: 20px !important;
    }
</style>
